import { Tooltip } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { usePermission } from '../../../../../../hooks/usePermission';
import { Booth } from '../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import InlineEditTextField from '../../../../pageBuilder/InlineEditTextField';

interface BoothHeaderTextEditInterface {
  booth: Booth;
  update: (path: string, value?: string | boolean) => Promise<void>;
}

const BoothHeaderTextEdit = ({ booth, update }: BoothHeaderTextEditInterface) => {
  const event = useSelector((state) => state.admin.event ?? state.common.event);
  const user = useSelector((state) => state.common.user);

  const { isEventHost } = usePermission();
  const { t } = useTranslation();

  const [boothnumber, setBoothnumber] = useState(booth.boothnumber);
  const [name, setName] = useState(booth.name);
  const [fieldsLoading, setFieldsLoading] = useState<string[]>([]);

  async function updateField(path: string, value?: string) {
    if ((path === 'name' && value !== booth.name) || (path === 'boothnumber' && value !== booth.boothnumber)) {
      setFieldsLoading([...fieldsLoading, path]);
      await update(path, value);
      setFieldsLoading(fieldsLoading.filter((e) => e !== path));
      toast.success(t('feedback:changes-saved'));
    }
  }

  return (
    <div className="flex flex-row">
      {event?.settings.useBoothNumber && (
        <InlineEditTextField
          name="boothnumber"
          label={t('booth:boothnumber')}
          defaultValue={booth.boothnumber}
          color="secondary"
          fullWidth
          disabled={!isEventHost(user)}
          onChange={(e) => setBoothnumber(e.target.value)}
          loading={fieldsLoading.includes('boothnumber')}
          onBlur={() => updateField('boothnumber', boothnumber)}
          saveButtonProps={{
            hidden: true,
          }}
        />
      )}

      <Tooltip placement="top" title={t('account:tooltip-boothname') as string}>
        <InlineEditTextField
          name="name"
          id="name-focus"
          label={t('account:boothname')}
          inputProps={{ maxLength: 70 }}
          defaultValue={booth.name}
          color="secondary"
          onChange={(e) => setName(e.target.value)}
          loading={fieldsLoading.includes('name')}
          disabled={!isEventHost(user) && !event?.settings?.allowUserRenameBooth}
          onBlur={() => updateField('name', name)}
          saveButtonProps={{
            hidden: true,
          }}
        />
      </Tooltip>
    </div>
  );
};
export default BoothHeaderTextEdit;
